import { IXandrNativeAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { nativeFbConditions } from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-fb-ad";
import { StackContext } from "../../context";
import { SiteNativeTemplate } from "../../native/native";

function fbOrSquareBlue(
  context: StackContext,
  adObject: IXandrNativeAdObject
): SiteNativeTemplate {
  if (nativeFbConditions(adObject)) {
    return "native_fb_ad";
  }
  return "native_square_blue";
}

// eslint-disable-next-line import/prefer-default-export
export { fbOrSquareBlue };
